<template>
  <div class="item-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>他们选择了瑞普</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="item" v-for="item in UrlList" :key="item.id">

        <el-image :src="'http://'+item.logoAddress" class="img" fit="cover"></el-image>
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ChooseBase",
    data(){
      return{
        Data:{'pageNumber':0,'pageSize':64},
        UrlList:{}
      }
    },

    created() {
    this.GetUrlList(this.Data)
    },
    methods:{
      GetUrlList(data){
        this.$axios.post('/api/cooperative/getAll',data).then(res=>{
          this.UrlList=res.data.data.records

        })
      }
    }
  }
</script>

<style lang="less" scoped>
.item-base{
  min-height: 81vh;
  .header{
    height: 44px;
    background: #F6F7F8;
    .header-content{
      line-height: 44px;
      margin: 0 auto;
      width: 74.5%;
      /*padding:10px;*/
    }
  }
  .content{
    width: 74.5vw;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px 0;
    .img{
      width: 7.8vw;
      height: auto;
    }
    .item{
      margin: 10px;
      span{
        display: block;
        text-align: center;
        height: 14px;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 21px;

      }
    }
  }
}
</style>